import React from 'react';
import QueryComponent from '@skooldio/skooldio-graphql-utils/dist/QueryComponent';

import { getMyExternalProfileInfo } from 'GraphQL/query/MyProfile.query';
import { getQuickAccessByProviderName } from 'Util/classroomProviderUtils';

import QuickAccessView from './QuickAccess';

const QuickAccess = (props) => (
  <QueryComponent query={getMyExternalProfileInfo}>
    {({ myExternalProfile }) => {
      const { providerName } = myExternalProfile || {};
      const quickAccessData = getQuickAccessByProviderName(providerName);
      const quickAccessItems = quickAccessData?.quickAccessItems ?? [];
      return <QuickAccessView quickAccessItems={quickAccessItems} {...props} />;
    }}
  </QueryComponent>
);

export default QuickAccess;
